import React from 'react';
import './FeatureSection.css';

const FeatureSection = () => {

    // Scroll Function
    const scrollToNewsletter = () => {
        const newsletterElement = document.getElementById('newsletter-signup');
        if (newsletterElement) {
            newsletterElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="feature-section">
            <div className="feature-header">
                <h1 className="feature-title">
                    The future of <span className="highlight-green">clinical grade</span>
                </h1>
                <h2 className="feature-subtitle">Gait Analysis & Treatment</h2>
                <p className="feature-description">
                    Ignoring foot health can lead to significant issues later in life. Studies show that children with flatfoot are at a higher risk for developing musculoskeletal problems. By addressing these concerns early with iWalk, parents can ensure their children enjoy a healthier, more active lifestyle.
                </p>
                
                {/* Button now scrolls to newsletter */}
                <button className="feature-button" onClick={scrollToNewsletter}>
                    Request Demo
                </button>
            </div>

            <div className="feature-icons">
                <div className="icon">
                    <img src="/Images/FS 1.svg" alt="Evidence-based" />
                    <p className="icon-description">Evidence-based interventions and measurement software are clinically studied.</p>
                </div>
                <div className="icon">
                    <img src="/Images/FS 2.svg" alt="Data-driven" />
                    <p className="icon-description">Data-driven approach allows for a easy, low-cost, and early stage integratable intervention.</p>
                </div>
                <div className="icon">
                    <img src="/Images/FS 3.svg" alt="Patient-focused" />
                    <p className="icon-description">Addressing our patient’s needs and outcomes are our primary objective. Clear data communication keeps healthcare transparent.</p>
                </div>
            </div>

            {/* Removed FS.png image from here */}
        </div>
    );
};

export default FeatureSection;
